import { Pipe, PipeTransform } from '@angular/core';
import { ICollapsedColumn } from "libraries/component/table/configurable-table/configurable-table.component";
import { TComputeValueInput } from "libraries/pipes/configurable-table/compute-value.pipe";
import { IBookingSearchResultConfig, IBookingSearchResultRow } from "libraries/interfaces/IConfigurableTable";
import { FindRowByIndexPipe } from "./find-row-by-index.pipe";
import { IsRowContainsColumnPipe } from "./is-row-contains-column.pipe";
import { ComputeColumnIndexPipe } from "./compute-column-index.pipe";
import { CanCreateTdPipe } from "./can-create-td";
import { IsSpecificCellPipe } from "./is-specific-cell.pipe";
import { IsVisibleRowPipe } from "./is-visible-row.pipe";

@Pipe({
    name: 'canCreateTdFullCondition',
})

export class CanCreateTdFullConditionPipe implements PipeTransform {
    constructor(
        private findRowByIndex: FindRowByIndexPipe,
        private isRowContainsColumn: IsRowContainsColumnPipe,
        private computeColumnIndex: ComputeColumnIndexPipe,
        private canCreateTd: CanCreateTdPipe,
        private isSpecificCell: IsSpecificCellPipe,
        private isVisibleRow: IsVisibleRowPipe,
    ) {
    }

    public transform(element: TComputeValueInput,
                     columnIndex: number,
                     rowIndex: number,
                     bookingIndex: number,
                     isLast: boolean,
                     columnArrayToDisplay: string[][],
                     config: IBookingSearchResultConfig,
                     pathByElementKey: { [key: string]: string },
                     row: IBookingSearchResultRow,
                     column: string,
                     collapsedRow: Array<ICollapsedColumn>): boolean {

        const isColapsable: boolean = this.isSpecificCell.transform(column, 'cC_');
        const isSelectable: boolean = this.isSpecificCell.transform(column, 'sC_');
        const isFixedTd: boolean = (isColapsable || isSelectable);
        const canCreateTd: boolean = this.canCreateTd.transform(element, columnIndex, rowIndex, bookingIndex, isFixedTd, isLast, columnArrayToDisplay, config, pathByElementKey);
        const isVisibleRow: boolean = this.isVisibleRow.transform(bookingIndex, row.collapserRef, collapsedRow);
        const isRowContainsColumn: boolean = this.isRowContainsColumn.transform(rowIndex, column, config);
        const hasRows: boolean = Boolean(this.findRowByIndex.transform(rowIndex, config).columnStructureArray?.length);
        const realColumnIndex: number = this.computeColumnIndex.transform(columnIndex, config);
        const colWidth: number = this.findRowByIndex.transform(rowIndex, config).columnStructureArray[realColumnIndex]?.colWidth;

        return Boolean(
            (canCreateTd &&
                ((isVisibleRow &&
                        isRowContainsColumn &&
                        hasRows &&
                        colWidth) ||
                    (isColapsable && isVisibleRow) ||
                    (isSelectable && isVisibleRow)
                )));
    }
}
